import { render, staticRenderFns } from "./locale-changer-header.vue?vue&type=template&id=5fdfd253"
import script from "./locale-changer-header.vue?vue&type=script&lang=js"
export * from "./locale-changer-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports